module.exports = __webpack_public_path__ + "img/yangImg3.6e4e30f7.jpg";